import React, { ButtonHTMLAttributes, FunctionComponent } from 'react';

import BaseButton from '../BaseButton';
import styleClassNames from './styles.module.scss';

const CloseButton: FunctionComponent<ButtonHTMLAttributes<HTMLButtonElement>> = (
  props
) => {
  const baseProps = {
    ...props,
    icon: 'bff-close',
    styleClassNames,
    variantName: 'close',
  };

  return <BaseButton {...baseProps} />;
};

export default CloseButton;
